import {
	getProductVariants,
	hasMultipleVariants,
	hasSingleVariant,
} from 'common/modules/products/variants';
import { ProductApi } from 'common/types/common';

export const getIncludedVariantIds = (
	stockProduct: ProductApi,
	allStockProducts: ProductApi[],
	selectedVariantId: string,
) => {
	if (!stockProduct.set) {
		if (selectedVariantId) {
			return [selectedVariantId];
		}
	}
	if (stockProduct.set) {
		const setChildren = allStockProducts.filter((p) =>
			(stockProduct.setProductIds || []).includes(p.id),
		);
		const setChildrenWithMultipleVariants = setChildren.filter(hasMultipleVariants);

		if (hasMultipleVariants(stockProduct) && !setChildrenWithMultipleVariants.length) {
			const variantIds = setChildren.map((child) => child.variants.options[0].id);
			return variantIds;
		}

		if (hasMultipleVariants(stockProduct) && setChildrenWithMultipleVariants.length) {
			return getIncludedVariantsOfChildrenWithOneVariant(setChildren);
		}

		if (setChildrenWithMultipleVariants.length >= 1) {
			const variantIds = getIncludedVariantsOfChildrenWithOneVariant(setChildren);
			variantIds.push(selectedVariantId);
			return variantIds;
		}
	}
	return [selectedVariantId];
};

export const getIncludedVariantsOfChildrenWithOneVariant = (setChildren: ProductApi[]) => {
	const variantIds = setChildren
		.filter(hasSingleVariant)
		.map((child) => getProductVariants(child)[0].id);
	return variantIds;
};
